export default __webpack_public_path__ + "img/03976e5f83a8b7c9db0f772a4298149d.svg";